<template>
    <div>
      <vehicle-entry-form :formSchema="formSchema" @reloadData="close"></vehicle-entry-form>
      <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
             
              <!-- Confirmation delete box -->
        <v-layout row justify-center>
            <v-dialog v-model="confirmModel" max-width="290">
                <v-card>
                    <v-card-text>Are you sure you want to delete this data?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmDelete(row_index, delete_id)">
                            Agree
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <!-- /Confirmation delete box -->
     <v-container>
 <v-card>
    <v-card-title>
	<span class="headline">Project's Vehicle List</span>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      
    >
    <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ ++(props.index) }}</td>
            <td class="text-xs-left">{{ (props.item.vehicle_name != null) ? (props.item.vehicle_name).slice(0, 20) + '...' : "N/A" }}</td>
            <td class="text-xs-left">{{ props.item.model_no }}</td>
            <td class="text-xs-left">{{ changeFormateDMY(props.item.purchase_date) }}</td>
            <td class="text-xs-left">{{ props.item.package_id }}</td>
            <td class="text-xs-left">{{ (props.item.registration != null) ? (props.item.registration).slice(0, 20) + '...' : "N/A"}}</td>
            <td class="text-xs-left">{{ props.item.engine_no }}</td>

            <td class="text-xs-left">

              <a v-if="props.item.document_01" :href="`${public_path}${props.item.document_01}`" target="_blank" rel="noopener noreferrer" download="">
               Document-01                
              </a>

              <a v-if="props.item.document_02" :href="`${public_path}${props.item.document_02}`" target="_blank" rel="noopener noreferrer" download="">Document-02                
              </a>

              <a v-if="props.item.document_03" :href="`${public_path}${props.item.document_03}`" target="_blank" rel="noopener noreferrer" download="">Document-03                
              </a>

            </td>

            <td class="text-xs-left">
               <span v-if="props.item.active" class="active">Yes</span>
              <span v-else class="in-active">No</span>
            </td>
            <td class="justify-center layout px-0">
                <v-btn icon class="mx-0"  @click="editItem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0"  @click="deleteItem(props.index, props.item.id)">
                    <v-icon color="pink">delete</v-icon>
                </v-btn>
            </td>

        </template> 

        <template slot="no-data" class="error">
       <div align="center"> No Data Found</div>
    </template>
    </v-data-table>
      <!-- <v-data-table item-key="name" class="elevation-1" loading loading-text="Loading... Please wait"></!--> 
  </v-card>
     </v-container>
     
    </div>
</template>
<script>
const commonService = require('../../../services/common.service');
import ServerPath from "../../../server-path/server-path";
import {preFix} from '../../../vuex/api'
import vehicleEntryForm from './vehicle_info_entry'
import Axios from 'axios'
export default {
    components:{
        vehicleEntryForm
    },
    data: () => ({
      showForm : false,
      valid: true,
      dialog: false,
      dialogEditForm:false,
      public_path:'',

     formSchema: {
      id: 0,
      asset_id:"",
      vehicle_name: "",
      model_no: "",
      engine_no: "",
      registration: "",
      fitness_issue_date:"",
      fitness_expire_date:"",
      insurance_issue_date:"",
      insurance_expire_date:"",
      tax_issue_date:"",
      tax_expire_date:"",
      purchase_date: "",
      package_id: "",
      remarks: "",
      document_01: "",
      document_02: "",
      document_03: "",
    },

      search: '',
      totalItems: 0,      
      loading: true,

      pagination: {
        sortBy: 'id',
        descending:true,
      },
      
      selected:[],
      search:'',      
      headers: [
      {
        text: 'Sl#',
        align: 'left',
        
        value: 'id'
      },
      {
        text: 'Vehicle Name',
        align: 'left',
        sortable: false,
        value: 'vehicle_name'
      },
      { text: 'Model No', align: 'left', value: 'model_no' },
      { text: 'Purchase Date', align: 'left', value: 'purchase_date' },
      { text: 'Package No.', align: 'left', value: 'package_id' },
      { text: 'Reg. No.', align: 'left', value: 'registration' },
      { text: 'Engine No.', value: 'engine_no' },
      { text: 'All Files', value: '' },
      { text: 'Active', value: 'active' },
      { text: 'Actions', value: '' ,align:'center'},

      
      ],
      items: [],
      
      item: {           
        edit: false,               
        head_id:'',
        related_account:'',
        name:'',
      },
      delete_id:'',
      row_index:'',
      dialog2: false,
      snackbar: false,
      color: 'success',
      mode: '',
      timeout: 3000,
      left:'left',
      message: '',
      confirmModel: false,
      select: null,
     SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    }),


    created(){
         this.public_path = ServerPath.serverPath;
    },

    computed: {
       userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    },
    },

    methods: {

     getDataFromApi(){  

      commonService.getAllData('vehicle_info').then(res => {                                    
        this.items = res.data;
        this.loading = false;
      });

      },

       changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },

      validateBeforeSubmit(e) {

      },
      reloadData(){
        this.showForm = this.userRole.saveButton;
        this.getDataFromApi()
        this.message = 'Data reloaded successfully!'
        this.snackbar = true
      },

      editItem (item) {
        item.purchase_date = this.changeFormateDMY(
              item.purchase_date
        );
        item.fitness_issue_date = this.changeFormateDMY(
              item.fitness_issue_date
        );
        item.fitness_expire_date = this.changeFormateDMY(
              item.fitness_expire_date
        );
        item.insurance_issue_date = this.changeFormateDMY(
              item.insurance_issue_date
        );
        item.insurance_expire_date = this.changeFormateDMY(
              item.insurance_expire_date
        );
        item.tax_issue_date = this.changeFormateDMY(
              item.tax_issue_date
        );
        item.tax_expire_date = this.changeFormateDMY(
              item.tax_expire_date
        );
        this.formSchema = item;
        this.showForm = true
        window.scrollTo({ // scroling to top
			    top: 0,
			    left: 100,
			    behavior: "smooth"
			  });
      },

      deleteItem (index,id) {          
        this.row_index = index;
        this.delete_id = id;                
        this.confirmModel = true;
      },

      confirmDelete(row_index,id){                    
        commonService.deleteRow(id, 'vehicle_info').then(res => {
        if (res.status == 1) {
          this.items.splice(row_index, 1);
          this.getDataFromApi();

        } else {
          this.SnackbarVal.color = "error";
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

        this.confirmModel = false;
        this.dialog2 = false;
              
        });       
      },
      close(res) {
      let $this = this;
      if (res.status == 1) {
        if (res.action == "add") {
          $this.items.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          let findindex = this.items.findIndex(
            (item) => item.id == res.data.id
          );
          this.row_index = findindex;
          this.$set(this.items, this.row_index, { ...res.data });
          this.row_index = "";
          this.formSchema.id = 0;
        }
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      }
      this.SnackbarVal.color = "success";
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    },

    },

    mounted () {
      this.getDataFromApi();
    },
}
</script>


// WEBPACK FOOTER //
// src/components/administration/vehicle_info/vehicle_info_list.vue